// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { unit } from 'mathjs'

import {
  castToFloat,
  roundToFixed,
} from 'helpers/reduxFormFunctions'

import {
  precisionKm,
  precisionMi,
} from 'config/constants'

const convertBetweenKMandMI = (value, toUnitType) => {
  // only allow numbers
  if (castToFloat(value) === null) {
    return null
  }

  // if toUnitType is 'mi' then the given value is 'km'
  const v = unit(value, toUnitType === 'SI' ? 'mi' : 'km')

  // value converted into toUnitType
  const c = v.toNumber(toUnitType === 'SI' ? 'km' : 'mi')

  // determine the degree of precision for the new value
  const p = toUnitType === 'SI' ? precisionKm : precisionMi

  return roundToFixed(c, p)
}

export default convertBetweenKMandMI
